// extracted by mini-css-extract-plugin
export var container = "_e4-0";
export var infoIcon = "_e4-2";
export var internalLabel = "_e4-3";
export var titleRowCol = "_e4-1";